import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { LogIn, Mail, Lock, AlertCircle, CheckCircle2 } from 'lucide-react';
import './Login.css';
import { auth } from '../../firebase/firebase-config';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [toast, setToast] = useState({ show: false, message: '', type: '' });
  const navigate = useNavigate();

  // 2 saniye sonra kaybolan bildirim fonksiyonu
  const showToast = (message, type) => {
    setToast({ show: true, message, type });
    setTimeout(() => setToast({ show: false, message: '', type: '' }), 2000);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      showToast('Giriş Başarılı! Panale gidiliyor...', 'success');
      // Başarılı girişte 2sn bekleyip yönlendirir
      setTimeout(() => navigate('/admin-panel'), 2000); 
    } catch (error) {
      showToast('Hata: Bilgileri kontrol ediniz!', 'error');
    }
  };

  return (
    <div className="login-wrapper">
      {/* 2 SANİYE GÖRÜNEN BİLDİRİM KUTUSU */}
      {toast.show && (
        <div className={`toast-box ${toast.type} toast-anim`}>
          {toast.type === 'success' ? <CheckCircle2 size={20} /> : <AlertCircle size={20} />}
          <span>{toast.message}</span>
        </div>
      )}

      <div className="login-card">
        <div className="login-brand">
          <div className="icon-circle">
            <LogIn size={30} />
          </div>
          <h2>Panel Girişi</h2>
          <p>Dr. Mahmut Aluç Yönetim Sistemi</p>
        </div>

        <form onSubmit={handleLogin} className="login-fields">
          <div className="field-group">
            <label><Mail size={16} /> E-Posta</label>
            <input 
              type="email" 
              placeholder="admin@scu.edu.tr" 
              required 
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="field-group">
            <label><Lock size={16} /> Şifre</label>
            <input 
              type="password" 
              placeholder="••••••••" 
              required 
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button type="submit" className="login-action-btn">
            Sisteme Giriş Yap
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;